__turbopack_context__.v({
  "container": "styles-module-scss-module__6D4ylW__container",
});
